/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type AutomaticRecordTypeEnum =
  (typeof AutomaticRecordTypeEnum)[keyof typeof AutomaticRecordTypeEnum];

export const AutomaticRecordTypeEnum = {
  automaticrecord: 'automaticrecord',
} as const;
